import React from 'react';
import FieldText from 'components/form/field/Text';

const Email = (props) => {
    return <FieldText { ...props } inputType="email"/>
};

export default Email;